import { render } from "./Transactions.vue?vue&type=template&id=6bdd54f3"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=6bdd54f3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__